import styled from "styled-components";
import { Main } from "./web-checkout.styles";

export const PaymentMain = styled(Main)`
  align-items: center;
  justify-content: center;
`;
